// import actions from './actions'
// import getters from './getters'
// import mutations from './mutations'
// import state from './state'

// export default {
//   namespaced: true,
//   actions,
//   getters,
//   mutations,
//   state
// }

const defaultState = {
  plant: 1,
};

const actions = {
  // getProducts: (context) => {
  //   fetchProducts
  //     .then((response) => {
  //       context.commit('PRODUCTS_UPDATED', response);
  //     })
  //     .catch((error) => {
  //       // eslint-disable-next-line
  //       console.error(error);
  //     });
  // },
  getPlant: (context) => {
    context.commit('COUNT_UPDATED')
  },
  getSelectedPlant: (context) => {
    context.commit('PLANT_UPDATE')
  }
};

const mutations = {
  COUNT_UPDATED: (state) => {
    state.plant++
  },
  PLANT_UPDATE: (state, newSelectedPlant) => {
    state.plant = newSelectedPlant
  }
  //   PRODUCTS_UPDATED: (state, products) => {
  //     state.products = products;
  // },
};

const getters = {
  plant: state => state.plant,
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
};
